module.exports = __webpack_public_path__ + "img/privilege_2_img3.ed842818.png";